








import Vue from 'vue'
export default Vue.extend({
  model: {
    prop: 'online'
  },
  props: {
    online: Boolean,
  },
  computed: {
    // iconString (): string { return this.online ? 'check_circle' : 'help' },
  }
})
